import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const movementType = v.union(
  v.literal("purchase"),
  v.literal("sale"),
  v.literal("return_in"),
  v.literal("return_out"),
  v.literal("adjustment"),
  v.literal("transfer_out"),
  v.literal("transfer_in"),
  v.literal("damage"),
  v.literal("expiration"),
  v.literal("loss"),
  v.literal("found"),
  v.literal("production"),
  v.literal("consumption"),
);

export const stockStatusType = v.union(
  v.literal("available"),
  v.literal("damaged"),
  v.literal("expired"),
  v.literal("lost"),
  v.literal("reserved"),
  v.literal("inTransit"),
  v.literal("quarantine"),
);

export const validatorStockMovement = v.object({
  productId: v.id("products"),
  warehouseId: v.optional(v.id("warehouses")),
  fromBranchId: v.optional(v.id("branches")),
  toBranchId: v.optional(v.id("branches")),

  movementType: movementType,

  fromStatus: v.optional(stockStatusType),
  toStatus: stockStatusType,

  quantity: v.number(),
  previousQuantity: v.number(),
  newQuantity: v.number(),

  reason: v.optional(v.string()),
  referenceType: v.optional(v.string()),
  referenceId: v.optional(v.string()),
  batchNumber: v.optional(v.string()),
  expirationDate: v.optional(v.number()),

  unitCost: v.optional(v.number()),
  totalCost: v.optional(v.number()),

  userId: v.id("users"),
  notes: v.optional(v.string()),
  attachmentIds: v.optional(v.array(v.id("_storage"))),

  internalControl,
});

export const stock_movements = defineTable(validatorStockMovement)
  .index("by_product", ["productId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch", ["internalControl.branchId"])
  .index("by_company_and_movement_type", [
    "internalControl.companyId",
    "movementType",
  ])
  .index("by_reference", ["referenceType", "referenceId"])
  .index("by_user", ["userId"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  // Dashboard: rango de fechas dentro de una sucursal sin traer toda la sucursal.
  .index("by_company_and_branch_and_created_at", [
    "internalControl.companyId",
    "internalControl.branchId",
    "internalControl.createdAt",
  ]);
